<template>
  <div class="edit-user">
    <fieldset>
      <legend>Balance management</legend>
      <template v-if="isPremium">
        <input type="number" v-model="adjustAmount" placeholder="Amount" />
        <input type="text" v-model="adjustNote" placeholder="Reason (optional)" />
        <button @click="adjustPoints">Do it</button>
        <hr />
      </template>
      <button @click.prevent="resyncBalance" :disabled="syncing">
        <i class="icon fas fa-sync" :class="{ 'fa-spin': syncing }"></i>
        Resync points
      </button>
      &ndash;
      Forces refresh of Twitch subscription and recalculates user's balance
    </fieldset>
    <fieldset>
      <legend>Configure roles</legend>
      <div>
        <input type="checkbox" v-model="flags.banned" />
        <strong>Banned</strong>
        <br />
        <small>Revokes ability to create submissions.</small>
      </div>
      <div>
        <input type="checkbox" v-model="flags.trusted" />
        <strong>Trusted</strong>
        <br />
        <small>Instantly approve user's submissions, skipping moderation.</small>
      </div>
      <button @click="updateRoles">Save</button>
    </fieldset>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import firebase from 'firebase'
import ApiHelper from '../mixins/ApiHelper'
import config from '../config'

export default {
  name: 'EditUser',
  props: ['user'],
  mixins: [ApiHelper],

  data () {
    return {
      adjustAmount: '',
      adjustNote: '',
      syncing: false,
      flags: {
        moderator: false,
        trusted: false,
        banned: false
      }
    }
  },

  computed: {
    ...mapGetters(['isPremium'])
  },

  watch: {
    user (user) {
      Object.assign(this.flags, user.flags || {})
    }
  },

  methods: {
    async adjustPoints () {
      const amount = Number(this.adjustAmount)
      const note = this.adjustNote

      await this.apiRequest(`user/${this.user.id}/transaction`, {
        method: 'post',
        data: {
          amount,
          note
        }
      })
      .then(() => {
        this.adjustAmount = ''
        this.adjustNote = ''
      })
      .catch(console.error)
    },

    async updateRoles () {
      const flags = this.flags
      await this.apiRequest(`user/${this.user.id}`, {
        method: 'patch',
        data: { flags }
      })
      .catch(console.error)
    },

    resyncBalance () {
      this.syncing = true
      this.apiRequest(`user/${this.user.id}/sync`)
        .finally(() => this.syncing = false)
    }
  }
}
</script>
